import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageKey, LocalStorageService } from '@services/local-storage';
import { Language, LANGUAGES } from './languages.data';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private codes: string[];

    public constructor(
        private readonly translateService: TranslateService,
        private readonly localStorageService: LocalStorageService
    ) {
        this.init();
    }

    public init() {
        this.codes = LANGUAGES.map((l) => l.code) || [];
        this.translateService.addLangs(this.codes);

        return this.translateService.use(this.findCode());
    }

    private findCodeByStorageKey() {
        const languageCode = this.localStorageService.getItem<string>(LocalStorageKey.Language);
        if (!languageCode) {
            return null;
        }
        return this.codes.find((c) => c === languageCode) ?? this.codes.find((c) => c.startsWith(languageCode));
    }

    private findCode() {
        const languageCode = this.findCodeByStorageKey();
        const browserCode = navigator.languages[0];

        return (
            languageCode ??
            this.codes.find((c) => c === browserCode) ??
            this.codes.find((c) => c.startsWith(browserCode)) ??
            'en-US'
        );
    }

    public setLanguage(language: Language) {
        this.translateService.use(language.code);
        this.localStorageService.setItem(LocalStorageKey.Language, language.code);
    }

    public getLanguage(): Language {
        const langauge = LANGUAGES.find((l) => l.code === this.findCode());
        console.log('langauge:' + langauge?.code);
        if (!langauge) {
            throw new Error('No language found');
        }
        return langauge;
    }

    public getLanguages() {
        return LANGUAGES;
    }

    public translate<T>(key: string[] | string, params?: Record<string, unknown>) {
        return this.translateService.instant(key, params) as T;
    }
}
